import { BitmapText, Container, Text } from "pixi.js";
import { Game } from "./Game";
import { ITransform } from "./ITransform";

export class FloatingText implements ITransform {
	private readonly text: Text;

	public constructor(parent: Container, text: string, public duration: number) {
		this.text = new Text({text});
		parent.addChild(this.container);
	}

	public tick(deltaMS: number, game: Game) {
		this.duration -= deltaMS;
		if (this.duration < 0) {
			this.text.removeFromParent();
			this.text.destroy();
		}
	}

	// region ITransform

	public get container(): Container {
		return this.text;
	}

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
